import constants from '@playcastdotio/GlobalConfig';
import type { FlowGraph } from '@playcastdotio/Messaging';

const ensureTrailingSlash = (url: string) => (url.endsWith('/') ? url : `${url}/`);

export const fetchFlowGraph = async (campaignId: string): Promise<FlowGraph | null> => {
  const baseUrl = ensureTrailingSlash(constants.REALTIME_API_BASE_URL);
  try {
    const response = await fetch(
      `${baseUrl}realtime/campaigns/${campaignId}/flow-graph`
    );
    if (!response.ok) return null;
    const data = await response.json();
    if (data?.isDefault) return null;
    return data?.data ?? null;
  } catch {
    return null;
  }
};
